import {createApp, defineAsyncComponent} from 'vue';
import emitter from "../../setup/bus";
import {i18n} from '../../setup/i18n';
import {VueReCaptcha} from "vue-recaptcha-v3";

export default function initTeaser() {
    const instances = document.querySelectorAll('.merkur-form');
    Array.prototype.forEach.call(instances, el => {


        const app = createApp({});
        app.config.globalProperties.$bus = emitter;
        app.provide('$bus', emitter);

        const merkurSiteKey = window.Merkur && window.Merkur.recaptchaPublicKey ? window.Merkur.recaptchaPublicKey : '6Ld9C1IcAAAAAN0byB8Ofak8gIFVprA9cBa-OFGH';

        app.use(i18n)
            .use(VueReCaptcha, { siteKey: merkurSiteKey })
            .component(
                'DccsForm',
                defineAsyncComponent(() => import('./DccsForm.vue'))
            )
            .component(
                'DccsInputField',
                defineAsyncComponent(() => import('./components/DccsInputField.vue'))
            )
            .component(
                'DccsCheckbox',
                defineAsyncComponent(() => import('./components/DccsCheckbox.vue'))
            )
            .component(
                'DccsFileField',
                defineAsyncComponent(() => import('./components/DccsFileField.vue'))
            )
            .component(
                'DccsTextarea',
                defineAsyncComponent(() => import('./components/DccsTextarea.vue'))
            )
            .component(
                'DccsRadio',
                defineAsyncComponent(() => import('./components/DccsRadio.vue'))
            )
            .component(
                'DccsSelectField',
                defineAsyncComponent(() => import('./components/DccsSelectField.vue'))
            )
            .component(
                'DccsHiddenField',
                defineAsyncComponent(() => import('./components/DccsHiddenField.vue'))
            )
            .mount(el);

        el.classList.remove('is-hidden');

    });
}
